import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Credibility } from '../components/Credibility';
import { Thesis } from '../components/Thesis';
import { WhoWeServe } from '../components/WhoWeServe';
import { HealthBridgeTeaser } from '../components/HealthBridgeTeaser';
import { TrustStrip } from '../components/TrustStrip';
import { CallToAction } from '../components/CallToAction';
import { Footer } from '../components/Footer';

export function HomePage() {
  const location = useLocation();

  React.useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      window.requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }, [location]);

  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Credibility />
      <Thesis />
      <HealthBridgeTeaser />
      <TrustStrip />
      <WhoWeServe />
      <CallToAction />
      <Footer />
    </div>
  );
}
